import Vue from 'vue';
import Router from 'vue-router';
import Chain from '../pages/Chain';

Vue.use(Router);
const _import = require('./_import_' + process.env.NODE_ENV);

export default new Router({
  // 去掉路由地址的#
  // mode: 'history', // 后端支持可开
  routes: [
    {path: '/', redirect: '/NotariaIndex'},
    {path: '/NotariaIndex/', component: _import('NotariaIndex')},
    {path: '/NotariaIndex2/', component: _import('NotariaIndex2')},
    {path: '/login', component: _import('Login')},
    {path: '/registry', component: _import('Registry')},
    {path: '/chain', component: _import('Chain')},
    {path: '/faceResult.html', component: _import('FaceResult'), name: 'faceResult'},
    {path: '/TransactGuide', component: _import('TransactGuide')},
    {path: '/GuidDetail', component: _import('GuidDetail')},
    {path: '/BidNotice', component: _import('BidNotice')},
    {path: '/AboutUs', component: _import('AboutUs')},
    {path: '/NotarAppointment', component: _import('NotarAppointment')},
    {path: '/Verification', component: _import('Verification')},
    {path: '/findPwd', component: _import('FindPassword')},
    {path: '/notarial-certificate-extract', component: _import('NotarialCertificateExtract')},
    {path: '/safe-keep-letter-extract', component: _import('SafeKeepLetterExtract')},
    {
      path: '/index',
      redirect: '/notarial',
      component: _import('Index'),
      children: [
        {
          path: '/notarial',
          component: _import('Notarial'),
          meta: {
            title: '常规公证',
            routeList: [
              {
                name: '常规公证',
              }],
          },
        },
        {
          path: '/notarial-detail',
          component: _import('AssignDetail'),
          meta: {
            title: '常规公证',
            routeList: [
              {
                name: '常规公证',
                link: '/notarial',
              }, {
                name: '公证详情',
              }],
          },
        },
        {
          path: '/notarial-apply',
          component: _import('NotarialApply'),
          meta: {
            title: '常规公证',
            routeList: [
              {
                name: '常规公证',
                link: '/notarial',
              }, {
                name: '申请公证',
              }],
          },
        },
        {
          path: '/Assign-apply',
          component: _import('AssignApply'),
          meta: {
            title: '常规公证',
            routeList: [
              {
                name: '常规公证',
                link: '/notarial',
              }, {
                name: '申请公证',
              }],
          },
        },
        {
          path: '/Assign-detail',
          component: _import('AssignDetail'),
          meta: {
            title: '常规公证',
            routeList: [
              {
                name: '常规公证',
                link: '/notarial',
              }, {
                name: '申请公证',
              }],
          },
        },
        {
          path: '/general-notarial-apply',
          component: _import('GeneralNotarization'),
          redirect: '/notarial',
          meta: {
            title: '一般公证',
            routeList: [
              {
                name: '一般公证',
                link: '/general-notarial',
              }, {
                name: '申请公证',
              }],
          },
        },
        {
          path: '/general-notarial',
          redirect: '/notarial',
          component: _import('GeneralNotarial'),
          meta: {
            title: '一般公证',
            routeList: [
              {
                name: '一般公证',
              }]
          },
        },
        {
          path: '/general-notarial-detail',
          redirect: '/notarial',
          component: _import('GeneralNotarialDetail'),
          meta: {
            title: '一般公证',
            routeList: [
              {
                name: '一般公证',
                link: '/general-notarial',
              }, {
                name: '公证详情',
              }],
          },
        },
        {
          path: '/execute',
          component: _import('Execute'),
          meta: {
            title: '赋强执行',
            routeList: [
              {
                name: '赋强执行',
              }],
          },
        },
        {
          path: '/execute-detail',
          // redirect: '/notarial',
          component: _import('ExecuteDetail'),
          meta: {
            title: '赋强执行详情',
            routeList: [
              {
                name: '赋强执行',
                link: '/execute',
              }, {
                name: '公证详情',
              }],
          },
        },
        {
          path: '/notarial-certificate',
          component: _import('NotarialCertificate'),
          meta: {
            title: '公证证书',
            icon: 'el-icon-s-management',
            routeList: [
              {
                name: '公证证书',
                icon: 'el-icon-s-management',
              }
            ],
          },
        },
        {
          path: '/notarial-certificate-detail',
          component: _import('NotarialCertificateDetail'),
          meta: {
            title: '公证证书详情',
            icon: 'el-icon-s-management',
            routeList: [
              {
                name: '公证证书详情',
                icon: 'el-icon-s-management',
              }
            ],
          },
        },
        {
          path: '/notarial-certificate-upload-evidence',
          component: _import('NotarialCertificateUploadEvidence'),
          meta: {
            title: '申请公证证书',
            icon: 'el-icon-s-management',
            routeList: [
              {
                name: '申请公证证书',
                icon: 'el-icon-s-management',
              }
            ],
          },
        },
        {
          path: '/notarial-certificate-replenish-material',
          component: _import('NotarialCertificateReplenishMaterial'),
          meta: {
            title: '公证证书补充材料',
            icon: 'el-icon-s-management',
            routeList: [
              {
                name: '公证证书补充材料',
                icon: 'el-icon-s-management',
              }
            ],
          },
        },
        {
          path: '/safe-keep-letter',
          component: _import('SafeKeepLetter'),
          meta: {
            title: '保管函',
            icon: 'el-icon-s-management',
            routeList: [
              {
                name: '保管函',
                icon: 'el-icon-s-management',
              }
            ],
          },
        },
        {
          path: '/safe-keep-letter-detail',
          component: _import('SafeKeepLetterDetail'),
          meta: {
            title: '保管函详情',
            icon: 'el-icon-s-management',
            routeList: [
              {
                name: '保管函详情',
                icon: 'el-icon-s-management',
              }
            ],
          },
        },
        {
          path: '/safe-keep-letter-upload-evidence',
          component: _import('SafeKeepLetterUploadEvidence'),
          meta: {
            title: '申请保管函',
            icon: 'el-icon-s-management',
            routeList: [
              {
                name: '申请保管函',
                icon: 'el-icon-s-management',
              }
            ],
          },
        },
        {
          path: '/safe-keep-letter-replenish-material',
          component: _import('SafeKeepLetterReplenishMaterial'),
          meta: {
            title: '保管函补充材料',
            icon: 'el-icon-s-management',
            routeList: [
              {
                name: '保管函补充材料',
                icon: 'el-icon-s-management',
              }
            ],
          },
        },
        {
          path: '/Appointment',
          component: _import('Appointment'),
          meta: {
            title: '我的预约',
            routeList: [
              {
                name: '我的预约',
              }
            ],
          },
        },
        {
          path: '/account',
          component: _import('Account'),
          meta: {
            title: '账户中心',
            routeList: [
              {
                name: '账户中心',
              }],
          },
        },
        {
          path: '/identity',
          component: _import('Identity'),
          meta: {
            title: '身份验证',
            routeList: [
              {
                name: '身份验证',
              }],
          },
        },
        {
          path: '/waitMatter',
          component: _import('WaitMatter'),
          meta: {
            title: '待办事项',
            routeList: [
              {
                name: '待办事项',
              }],
          },
        },
        {
          path: '/UserDetail',
          component: _import('UserDetail'),
          meta: {
            title: '基本资料',
            routeList: [
              {
                name: '基本资料',
              }],
          },
        },
        {
          path: '/ChangePassword',
          component: _import('ChangePassword'),
          meta: {
            title: '修改密码',
            routeList: [
              {
                name: '修改密码',
              }],
          },
        },
        {
          path: '/electronic',
          component: _import('electronic'),
          meta: {
            title: '公证电子签',
            routeList: [
              {
                name: '公证电子签',
              }],
          },
        },

      ],
    },

  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js